import i18next from 'i18next'
import {SelectItem} from '@/components/dumb/Select'

export const statusSelectOptions: () => SelectItem[] = () =>
    Object.entries(i18next.t('enums:chargebackStatus', {returnObjects: true})).map(
        ([value, label]) => ({
            value,
            label
        })
    )
